import { render, staticRenderFns } from "./agv-ri-contacts.vue?vue&type=template&id=07ab05c2&scoped=true&lang=pug&"
import script from "./agv-ri-contacts.vue?vue&type=script&lang=js&"
export * from "./agv-ri-contacts.vue?vue&type=script&lang=js&"
import style0 from "./agv-ri-contacts.vue?vue&type=style&index=0&id=07ab05c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ab05c2",
  null
  
)

export default component.exports